import React from "react";
import PhoneInput from "react-phone-number-input";
import { WrappedFieldProps } from "redux-form";

const TelephoneField = (props: WrappedFieldProps) => (
  <PhoneInput {...props.input} />
);

export default TelephoneField;
